import { call, put, takeLatest } from "redux-saga/effects";

import { cancelSubscriptionFail, cancelSubscriptionSuccess, getSubscriptionFail, getSubscriptionSuccess, startTrialFail, startTrialSuccess } from "../actions/subscription";

import { toast } from "react-toastify";
import api from "../../utils/api-helper/api";
import { localePath } from "../../i18n/config";
import { CANCEL_SUBSCRIPTION_REQUEST, GET_SUBSCRIPTION_REQUEST, GetSubscriptionRequestAction, START_TRIAL_REQUEST } from "../types";
import { getUserSaga } from "./user";

function* cancelSubscriptionSaga(action: any) {
    try {
        const { history } = action.payload;
        //@ts-ignore
        yield api.post("/subscription/cancel");
        yield put(cancelSubscriptionSuccess());
        yield call(getUserSaga);
        history.push(localePath("subscription_end"));
    } catch (error: any) {
        toast.error(error.response?.data?.message || "Failed to cancel subscription", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(cancelSubscriptionFail(error));
    }
}

function* getSubscriptionSaga(action: GetSubscriptionRequestAction) {
    try {
        const { id } = action.payload;
        //@ts-ignore
        const response = yield api.get(`subscription/user/${id}`);
        const data = response.data;
        yield put(getSubscriptionSuccess(data));
    } catch (error: any) {
        yield put(getSubscriptionFail(error));
    }
}

function* startTrialSaga(action: any) {
    const history = action.payload.history;
    const customerTrialEmailId = action.payload.customerTrialEmailId;
    try {
        //@ts-ignore
        const response = yield api.post("user/normal/appOnly/trial", {
            ...(customerTrialEmailId && { customerTrialEmailId }),
            ...(action.payload.region && { region: action.payload.region }),
        });
        const data = response.data;
        yield put(startTrialSuccess(data));
        yield call(getUserSaga);
        toast.success(response?.data?.message || "Trial started successfully", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        history.push(localePath("tili", "tilaus"));
    } catch (error: any) {
        toast.error(error.response?.data?.message || "Failed to start subscription trial", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(startTrialFail(error));
    }
}

const subscriptionWatcher = [takeLatest(CANCEL_SUBSCRIPTION_REQUEST, cancelSubscriptionSaga), takeLatest(GET_SUBSCRIPTION_REQUEST, getSubscriptionSaga), takeLatest(START_TRIAL_REQUEST, startTrialSaga)];

export default subscriptionWatcher;
